import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	categoryItem: {
		height: '32px',
		minWidth: '80px',
		flex: '1',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.medium'),
	},
});

export const SnippetCategorySelectorSkeleton = (): React.JSX.Element => {
	return (
		<Inline space="space.100">
			<Box xcss={styles.categoryItem} />
			<Box xcss={styles.categoryItem} />
			<Box xcss={styles.categoryItem} />
		</Inline>
	);
};
